// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Z95K","notes":"Notes_notes__1ne92"};